'use client';

import { c as _c } from "react/compiler-runtime";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
const Toaster = t0 => {
  const $ = _c(19);
  let icons;
  let props;
  let style;
  if ($[0] !== t0) {
    ({
      icons,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = icons;
    $[2] = props;
    $[3] = style;
  } else {
    icons = $[1];
    props = $[2];
    style = $[3];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "system" : t1;
  const t2 = theme as ToasterProps['theme'];
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      classNames: {
        toast: "border-border bg-popover text-popover-foreground shadow-lg",
        title: "text-foreground",
        description: "!text-popover-foreground",
        actionButton: "bg-primary text-primary-foreground",
        cancelButton: "bg-muted text-muted-foreground"
      }
    };
    t4 = <CircleCheckIcon className="size-4" />;
    t5 = <InfoIcon className="size-4" />;
    t6 = <TriangleAlertIcon className="size-4" />;
    t7 = <OctagonXIcon className="size-4" />;
    t8 = <Loader2Icon className="size-4 animate-spin" />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== icons) {
    t9 = {
      success: t4,
      info: t5,
      warning: t6,
      error: t7,
      loading: t8,
      ...icons
    };
    $[10] = icons;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== style) {
    t10 = {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)",
      "--border-radius": "var(--radius)",
      ...style
    };
    $[12] = style;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = t10 as React.CSSProperties;
  let t12;
  if ($[14] !== props || $[15] !== t11 || $[16] !== t2 || $[17] !== t9) {
    t12 = <Sonner theme={t2} className="toaster group" toastOptions={t3} icons={t9} style={t11} {...props} />;
    $[14] = props;
    $[15] = t11;
    $[16] = t2;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
export { Toaster };